import { Component, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { EXIT_INTENT_PHONE_NUMBER, EXIT_INTENT_PHONE_NUMBER_TEL } from '@config/exit-intent.constants';
import { ExitIntentService } from '@services/exit-intent.service';
import { DialogModule } from 'primeng/dialog';

@Component({
    selector: 'isi-dtc-exit-intent-dialog',
    imports: [DialogModule, TranslateModule],
    templateUrl: './exit-intent-dialog.component.html',
})
export class ExitIntentDialogComponent {
    readonly service = inject(ExitIntentService);
    readonly phoneNumber = EXIT_INTENT_PHONE_NUMBER;
    readonly phoneNumberTel = EXIT_INTENT_PHONE_NUMBER_TEL;
}
